import type { AfterViewInit } from '@angular/core';
import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { EventName, EventService } from '@accesso/cc-std-lib';

import { PageSetupService } from './core/page-setup/page-setup.service';
import { MerchantStore } from './feature/merchant/merchant.store';

@Component({
	selector: 'app-root',
	imports: [RouterOutlet],
	templateUrl: './app.component.html',
	styleUrl: './app.component.scss',
})
export class AppComponent implements AfterViewInit {
	private readonly pageSetupService = inject(PageSetupService);
	private readonly event = inject(EventService);
	private merchantStore = inject(MerchantStore);

	merchant = this.merchantStore.merchant;

	ngAfterViewInit(): void {
		const merchant = this.merchant();
		if (!merchant) return;
		this.pageSetupService.initialize();

		const store = this.merchantStore.store();
		if (store) {
			const { tenant, language, venue, industry } = store;

			this.event.publish({
				event: EventName.INITIALIZE,
				details: {
					tenant: tenant(),
					language: language(),
					venue: venue(),
					industry: industry(),
					merchantId: merchant.id,
				},
			});
		}
	}
}
